import $ from "jquery";
import Sentry from "sentry_browser";
import initialPageData from "hqwebapp/js/initial_page_data";
import FormplayerFrontend from "cloudcare/js/formplayer/app";
import UsersModels from "cloudcare/js/formplayer/users/models";

var self = {};
self.Users = {
    /**
     * logInAsUser
     * :param: {String} restoreAsUsername - The username to restore as. Does not include
     *      `@<domain>.commcarehq.org` suffix
     * Logs a user in by setting the property on the current user and
     * setting it in a cookie
     */
    logInAsUser: function (restoreAsUsername) {
        var currentUser = UsersModels.getCurrentUser();
        currentUser.restoreAs = restoreAsUsername;
        Sentry.setTag("loginAsUser", restoreAsUsername);

        $.cookie(
            self.Users.restoreAsKey(
                currentUser.domain,
                currentUser.username,
            ),
            currentUser.restoreAs,
            { secure: initialPageData.get('secure_cookies') },
        );
    },
    restoreAsKey: function (domain, username) {
        return 'restoreAs:' + domain + ':' + username;
    },
    /**
     * getRestoreAsUser
     *
     * :param: {String} domain
     * :param: {String} username - username of the current user
     *
     * Returns the restore as user from the cookies or null if it doesn't exist
     */
    getRestoreAsUser: function (domain, username) {
        return $.cookie(self.Users.restoreAsKey(domain, username)) || null;
    },

    /**
     * clearRestoreAsUser
     *
     * :param: {String} domain
     * :param: {String} username - username of the current user
     *
     * Clears the restore as user from the cookies
     */
    clearRestoreAsUser: function (domain, username) {
        Sentry.setTag("loginAsUser", null);
        return $.removeCookie(self.Users.restoreAsKey(domain, username));
    },
};

FormplayerFrontend.getChannel().reply('restoreAsUser', function (domain, username) {
    return self.Users.getRestoreAsUser(
        domain,
        username,
    );
});

/**
 * clearRestoreAsUser
 *
 * This will unset the localStorage restore as user as well as
 * unset the restore as user from the currentUser. It then
 * navigates you to the main page.
 */
FormplayerFrontend.on('clearRestoreAsUser', function () {
    var user = UsersModels.getCurrentUser();
    self.Users.clearRestoreAsUser(
        user.domain,
        user.username,
    );
    user.restoreAs = null;
    FormplayerFrontend.showRestoreAs(user);
    FormplayerFrontend.trigger('navigateHome');
});

export default self;
